/**
 * Landing Page V2 - Footer Section
 *
 * This component now uses the common Footer component
 * Maintained for backward compatibility
 */

'use client';

import React from 'react';
import { Footer } from '@/components/common/Footer';

export function FooterSection() {
  return <Footer />;
}
